import React from "react";

interface IconProps {
  color?: string;
  size?: number;
  className?: string;
}

export const ApiIcon: React.FC<IconProps> = ({
  color = "currentColor",
  size = 24,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 13C12.44 13.56 11.55 13.56 11 13.01V13C10.45 12.45 10.45 11.56 11 11.01V11C11.55 10.45 12.44 10.45 12.99 11H13C13.55 11.55 13.55 12.45 13 13ZM12 5.99996L14.12 8.11996L16.62 5.61996L13.42 2.41996C12.64 1.63996 11.37 1.63996 10.59 2.41996L7.38996 5.61996L9.88996 8.11996L12 5.99996ZM5.99996 12L8.11996 9.87996L5.61996 7.37996L2.41996 10.58C1.63996 11.36 1.63996 12.63 2.41996 13.41L5.61996 16.61L8.11996 14.11L5.99996 12ZM18 12L15.88 14.12L18.38 16.62L21.58 13.42C22.36 12.64 22.36 11.37 21.58 10.59L18.38 7.38996L15.88 9.88996L18 12ZM12 18L9.87996 15.88L7.37996 18.38L10.58 21.58C11.36 22.36 12.63 22.36 13.41 21.58L16.61 18.38L14.11 15.88L12 18Z"
      fill={color}
    />
  </svg>
);

export const EventIcon: React.FC<IconProps> = ({
  color = "currentColor",
  size = 24,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 13H13C12.45 13 12 13.45 12 14V17C12 17.55 12.45 18 13 18H16C16.55 18 17 17.55 17 17V14C17 13.45 16.55 13 16 13ZM16 3V4H8V3C8 2.45 7.55 2 7 2C6.45 2 6 2.45 6 3V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4H18V3C18 2.45 17.55 2 17 2C16.45 2 16 2.45 16 3ZM18 20H6C5.45 20 5 19.55 5 19V9H19V19C19 19.55 18.55 20 18 20Z"
      fill={color}
    />
  </svg>
);

export const PeopleAltIcon: React.FC<IconProps> = ({
  color = "currentColor",
  size = 24,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 13C11.67 13 17 14.34 17 17V20H1V17C1 14.34 6.33 13 9 13ZM16.6699 13.1299C19.4299 13.5299 23 14.82 23 17V20H19V17C19 15.32 18.0399 14.0599 16.6699 13.1299ZM9 15C6.30027 15 3.20056 16.2897 3 17.0098V18H15V17C14.8 16.29 11.7 15 9 15ZM9 4C11.21 4 13 5.79 13 8C13 10.21 11.21 12 9 12C6.79 12 5 10.21 5 8C5 5.79 6.79 4 9 4ZM15 4C17.21 4.00004 19 5.79003 19 8C19 10.21 17.21 12 15 12C14.53 12 14.0899 11.8998 13.6699 11.7598C14.4999 10.7298 15 9.41993 15 8C15 6.58007 14.4999 5.27021 13.6699 4.24023C14.0899 4.10023 14.53 4 15 4ZM9 6C7.9 6 7 6.9 7 8C7 9.1 7.9 10 9 10C10.1 10 11 9.1 11 8C11 6.9 10.1 6 9 6Z"
      fill={color}
    />
  </svg>
);

export const PersonOutlineIcon: React.FC<IconProps> = ({
  color = "currentColor",
  size = 24,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 5.9C13.16 5.9 14.1 6.84 14.1 8C14.1 9.16 13.16 10.1 12 10.1C10.84 10.1 9.9 9.16 9.9 8C9.9 6.84 10.84 5.9 12 5.9ZM12 14.9C14.97 14.9 18.1 16.36 18.1 17V18.1H5.9V17C5.9 16.36 9.03 14.9 12 14.9ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V20H20V17C20 14.34 14.67 13 12 13Z"
      fill={color}
    />
  </svg>
);

export const CorporateFareIcon: React.FC<IconProps> = ({
  color = "currentColor",
  size = 24,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 7V3H2V21H22V7H12ZM10 19H4V17H10V19ZM10 15H4V13H10V15ZM10 11H4V9H10V11ZM10 7H4V5H10V7ZM20 19H12V9H20V19ZM18 11H14V13H18V11ZM18 15H14V17H18V15Z"
      fill={color}
    />
  </svg>
);

export const CalendarIcon: React.FC<IconProps> = ({
  color = "currentColor",
  size = 20,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.6665 2.49998H15.8332V1.66665C15.8332 1.20831 15.4582 0.833313 14.9998 0.833313C14.5415 0.833313 14.1665 1.20831 14.1665 1.66665V2.49998H5.83317V1.66665C5.83317 1.20831 5.45817 0.833313 4.99984 0.833313C4.5415 0.833313 4.1665 1.20831 4.1665 1.66665V2.49998H3.33317C2.4165 2.49998 1.6665 3.24998 1.6665 4.16665V17.5C1.6665 18.4166 2.4165 19.1666 3.33317 19.1666H16.6665C17.5832 19.1666 18.3332 18.4166 18.3332 17.5V4.16665C18.3332 3.24998 17.5832 2.49998 16.6665 2.49998ZM15.8332 17.5H4.1665C3.70817 17.5 3.33317 17.125 3.33317 16.6666V6.66665H16.6665V16.6666C16.6665 17.125 16.2915 17.5 15.8332 17.5Z"
      fill={color}
    />
  </svg>
);

export const ProjectIcon: React.FC<IconProps> = ({
  color = "currentColor",
  size = 24,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.87206 21.9869C7.61763 22.0934 8.30837 21.5753 8.41488 20.8298L8.95266 17.0653H13.6001L13.1175 20.4441C13.0109 21.1896 13.529 21.8804 14.2746 21.9869C15.0201 22.0934 15.7109 21.5753 15.8174 20.8298L16.3552 17.0653H19.8142C20.5674 17.0653 21.1779 16.4548 21.1779 15.7016C21.1779 14.9485 20.5674 14.338 19.8142 14.338H16.7448L17.4127 9.6628H20.6363C21.3895 9.6628 22 9.05227 22 8.29914C22 7.546 21.3895 6.93547 20.6363 6.93547H17.8023L18.285 3.55669C18.3915 2.81113 17.8734 2.12039 17.1279 2.01388C16.3823 1.90737 15.6916 2.42543 15.585 3.17099L15.0473 6.93547H10.3998L10.8825 3.55669C10.989 2.81113 10.4709 2.12039 9.72535 2.01388C8.97979 1.90737 8.28905 2.42543 8.18254 3.17099L7.64476 6.93547H4.18577C3.43264 6.93547 2.82211 7.546 2.82211 8.29914C2.82211 9.05227 3.43264 9.6628 4.18577 9.6628H7.25514L6.58726 14.338H3.36367C2.61053 14.338 2 14.9485 2 15.7016C2 16.4548 2.61053 17.0653 3.36367 17.0653H6.19764L5.71496 20.4441C5.60845 21.1896 6.1265 21.8804 6.87206 21.9869ZM14.6576 9.6628H10.0102L9.34228 14.338H13.9898L14.6576 9.6628Z"
      fill={color}
    />
  </svg>
);

export const AiInsightIcon: React.FC<IconProps> = ({
  color = "currentColor",
  size = 24,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 8C22.1 8 23 8.9 23 10C23 11.4499 21.5602 12.2596 20.4902 11.9297L16.9297 15.4805C17.2694 16.5604 16.4498 18 15 18C13.5402 18 12.7306 16.5504 13.0703 15.4805L10.5195 12.9297C10.2197 13.0195 9.78035 13.0195 9.48047 12.9297L4.92969 17.4902C5.25958 18.5602 4.44994 20 3 20C1.9 20 1 19.1 1 18C1 16.5501 2.43978 15.7404 3.50977 16.0703L8.07031 11.5195C7.73059 10.4396 8.55015 9 10 9C11.4598 9 12.2694 10.4496 11.9297 11.5195L14.4805 14.0703C14.7803 13.9805 15.2197 13.9805 15.5195 14.0703L19.0703 10.5098C18.7404 9.43978 19.5501 8 21 8ZM4 8L6 8.5L4 9L3.5 11L3 9L1 8.5L3 8L3.5 6L4 8ZM15.9404 5.07031L18 6L15.9404 6.92969L15 9L14.0801 6.92969L12 6L14.0801 5.07031L15 3L15.9404 5.07031Z"
      fill={color}
    />
  </svg>
);
